import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from 'global/views/Home.vue'
import Login from 'global/views/Login.vue'
import PersonManager from 'global/components/person-manager-new.vue'
import jwtDecode from 'global/auth/cd-jwt'
import store from '../store'
Vue.use(VueRouter);

const intersection = (left, right) => {
    if (left == undefined || right == undefined) return []
    if (Array.isArray(left)) {
        return left.filter(value => right.includes(value));
    } else {
        return [left].filter(value => right.includes(value))
    }
}
const allowCurrentObject = (title) => ({
    title: title,
    allow(token, from, to, next) {
        const intersect = intersection(token['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'], ['admin'])
        // а тут мы разрешим открыть страницу или админу,
        // или гражданину, чей обжект-айди совпадает с айди объекта, 
        // карточку которого он открывает
        if (intersect.length > 0 || to.params.object_id === token.ObjectID) {
            document.title = title ?? to.name
            next()
        } else {
            next(new Error('Недостаточно прав'))
        }
    },

})
const allowCurrentUser = (title) => ({
    allow(token, from, to, next) {
        const intersect = intersection(token['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'], ['admin'])
        // а тут мы разрешим открыть страницу или админу,
        // или гражданину, чей UserID совпадает с айди из параметров маршрута, 
        if (intersect.length > 0 || to.params.user_id === token.Id) {
            document.title = title ?? to.name
            next()
        } else {
            next(new Error('Недостаточно прав'))
        }
    },
    title: title
})
const allowAdmin = (title, and) => ({
    allow(token, from, to, next) {
        const intersect = intersection(token['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'], ['admin', and])
        // а тут мы разрешим открыть страницу или админу,
        // или гражданину, чей UserID совпадает с айди из параметров маршрута, 
        if (intersect.length > 0) {
            document.title = title ?? to.name
            next()
        } else {
            next(new Error('Недостаточно прав'))
        }
    }
})
const routes = [
    {
        path: '/',
        component: Home,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: '/',
                name: 'selector',
                component: (...args) => import('global/components/cd-app-selector'),
                props: true,
                beforeEnter(to, from, next) {
                    try {
                        const token = jwtDecode(localStorage.getItem('token'));
                        const roles = token['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']
                        if (roles.indexOf('ctc_exec') >= 0) {
                            next('/Calls')
                        } else {
                            next()
                        }
                    }
                    catch (err) {
                        localStorage.removeItem('token')
                        //next('/login')
                    }
                },
                meta: {
                    title: 'Главная'
                }
            },
            {
                path: '/Dev',
                name: 'devel',
                component: () => import('global/views/Dev.vue'),
                meta: allowAdmin('Разработчикам')
            },
            {
                path: '/FAQ',
                name: 'faq',
                component: { template: '<div>Здесь будут вопросы и ответы</div>' },
                meta: {
                    title: 'Вопросы и ответы'
                }
            },
            {
                path: '/WordExport',
                name: 'word_export',
                component: () => import('../views/WordExport.vue')
            },
            {
                path: '/Calls',
                name: 'calls',
                meta: {
                    title: 'Журнал регистрации звонков'
                },
                component: () => import('../views/Calls.vue')
            },
            {
                path: '/Call/:call_id',
                name: 'call',
                meta: {
                    title: 'Звонок'
                },
                component: () => import('../views/Call.vue'),
                props: route => ({ call_id: +route.params.call_id })
            },
            {
                path: '/Users',
                name: 'UserManager',
                meta: {
                    title: 'Управление пользователями',
                    allow(token, from, to, next) {
                        // эта функция становится продолжением коллбэка beforeEach
                        // при здесь мы знаем, что сравнивать и с чем
                        // при разрешении перехода на маршрут

                        // нашли пересечение ролей в токене и админа
                        const intersect = intersection(token['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'], ['admin', 'user-manager'])
                        // тут всё просто
                        if (intersect.length > 0) {
                            // идём дальше
                            document.title = 'Управление пользователями'
                            next()
                        } else {
                            // идём лесом, то есть откуда пришли
                            next(from)
                        }
                    }
                },
                component: () => import('global/views/Users.vue')
            },
            {
                path: '/Users/:user_id',
                name: 'user-info',
                component: () => import('global/views/User.vue'),
                meta: allowCurrentUser('Карточка пользователя')
            },
            {
                name: 'config',
                path: '/Configure',
                component: () => import('global/views/Configure.vue'),
                children: [
                    {
                        path: 'Menu',
                        name: 'menu-config',
                        component: () => import('global/admin/menu-role-editor.vue'),
                        props: { appid: 5 },
                        meta: allowAdmin('Редактор меню', 'menu-manager'),
                    },
                    {
                        path: 'ObjectGroup',
                        name: 'group-config',
                        component: () => import('global/admin/glb-role-editor.vue'),
                        meta: {
                            title: 'Управление доступом к типам объектов'
                        }
                    },
                    {
                        path: 'Objects',
                        name: 'objects-config',
                        meta: {
                            title: 'Справочник объектов'
                        },
                        component: () => import('global/components/object-grid.vue')
                    },
                    {
                        path: 'Objects/:object_id',
                        component: () => import('global/views/Object.vue'),
                        meta: {
                            title: 'Карточка учреждения'
                        },
                        children: [
                            {
                                path: '/',
                                name: 'object-details',
                                component: () => import('global/components/object-card.vue'),
                                meta: allowCurrentObject('Карточка учреждения'),
                            },
                            {
                                path: 'persons',
                                name: 'object-persons',
                                component: PersonManager,
                                meta: allowCurrentObject('Справочник персонала'),
                            },
                            {
                                path: 'contragent',
                                name: 'object-contragent-responsible',
                                component: () => import('global/components/object-contragent-grid.vue'),
                                meta: allowCurrentObject('Контрагенты'),
                            },
                            {
                                path: 'contracts',
                                name: 'object-contracts',
                                component: () => import('../components/global/contracts-grid.vue'),
                                meta: allowAdmin('Договоры')
                            },
                        ]
                    },
                    {
                        path: 'Roles',
                        name: 'roles-config',
                        component: () => import('global/views/Roles.vue'),
                        meta: allowAdmin('Управление ролями')
                    }
                ]
            },
            {
                path: '/Persons',
                name: 'person-config',
                meta: {
                    title: 'Справочник персонала'
                },
                component: PersonManager
            },
            {
                path: '/Persons/:person_id',
                name: 'person-card',
                component: () => import('global/components/person-card.vue')
            },
            {
                path: '/Contragents',
                name: 'contragent-config',
                meta: {
                    title: 'Справочник контрагентов'
                },
                component: () => import('global/views/Contragents.vue')
            },
            {
                path: '/Contracts',
                name: 'Contracts-config',
                meta: {
                    title: 'Договоры'
                },
                component: () => import('../components/global/contracts-grid.vue')
            },
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
    },
    {
        path: '/logout',
        name: 'logout',
        beforeEnter(to, from, next) {
            next('login')
        }
    }

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {

    if (to.name != 'login' && to.name != 'logout') {
        const { _actions } = store
        const actions = Object.values(_actions)
        Promise
            .all(actions.map(a => Promise.all(a.map(m => Promise.resolve(m())))))
            .then(() => Promise.resolve(console.log('ready')))
            .then(() => {
                if (to.matched.some(record => record.meta.requiresAuth)) {
                    const storagedata = localStorage.getItem('token');
                    try {
                        const decode = jwtDecode(storagedata);
                        Vue.set(to.meta, 'jwt', decode)
                        next()
                    }
                    catch (error) {
                        //localStorage.removeItem('token')
                        next('logout')
                    }
                } else {
                    next()
                }
            })
    } else {
        store.dispatch('reset', true).then(() => localStorage.removeItem('token')).then(() => next())
    }

})


export default router;
